import React from 'react';
import OverriddenIcon from './OverriddenIcon';

const Overridden = ({ isOverridden, ...rest }) => (isOverridden ? <OverriddenIcon {...rest} /> : null);

export default Overridden;
